import { rssiQuality } from "../lib/format.js";

const LABELS = {
  excellent: "excelente",
  good: "bom",
  fair: "regular",
  poor: "ruim",
  unknown: "—",
};

export default function RssiBadge({ rssi }) {
  const q = rssiQuality(rssi);
  const n = Number(rssi);
  const display = Number.isFinite(n) ? `${n} dBm` : "—";
  const klass =
    q === "excellent" || q === "good"
      ? "badge-ok"
      : q === "fair"
        ? "badge-warn"
        : q === "poor"
          ? "badge-err"
          : "badge-muted";
  return (
    <span className={klass} title={`Qualidade: ${LABELS[q]}`}>
      <span className="font-mono">{display}</span>
    </span>
  );
}
